import { STROKE_WIDTH, SVG_H, SVG_W, TRUNK_X } from './tree.consts';

interface TreeConnectorProps {
  isLastChild: boolean;
  left?: number;
}

const CURVE_START_Y = 4;
const KNEE_DEPTH = 6;
const KNEE_X = 8.3;
const KNEE_Y = 8.2;
const END_X = 18;
const END_Y = 16;
const BRANCH_PATH = `C${TRUNK_X},${KNEE_DEPTH} 7.7,7.8 ${KNEE_X},${KNEE_Y} L${END_X},${END_Y}`;
const TRUNK_OVERFLOW = 4;

const TreeConnector = ({ isLastChild, left = -SVG_W }: TreeConnectorProps) => (
  <svg
    width={SVG_W}
    height="100%"
    viewBox={`0 0 ${SVG_W} ${SVG_H}`}
    preserveAspectRatio="none"
    style={{
      position: 'absolute',
      left,
      top: 0,
      pointerEvents: 'none',
      overflow: 'visible',
    }}
  >
    <path
      d={
        isLastChild
          ? `M${TRUNK_X},-${TRUNK_OVERFLOW} L${TRUNK_X},${CURVE_START_Y} ${BRANCH_PATH}`
          : `M${TRUNK_X},-${TRUNK_OVERFLOW} L${TRUNK_X},${SVG_H} M${TRUNK_X},${CURVE_START_Y} ${BRANCH_PATH}`
      }
      stroke="currentColor"
      strokeWidth={STROKE_WIDTH}
      fill="none"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);

export default TreeConnector;
